<div class="office-assignment-container">
  <!-- List View -->
  <ng-container *ngIf="!showForm; else assignmentForm">
    <irembogov-office-assignment-list
      [assignments]="assignments"
      (add)="onAddNew()"
      (edit)="onEdit($event)"
      (delete)="onDelete($event)">
    </irembogov-office-assignment-list>
  </ng-container>

  <!-- Form View -->
  <ng-template #assignmentForm>
    <div class="card">
      <div class="card-body">
        <!-- Back Navigation -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <button
            (click)="onCancel()"
            class="btn btn-link text-decoration-none p-0">
            <i class="fa-solid fa-angles-left me-2"></i>
            Back to Assignments
          </button>
          <h6 class="mb-0">
            {{ selectedAssignment ? 'Edit' : 'New' }} Office Assignment
          </h6>
        </div>

        <!-- State Selection -->
        <div class="mb-4">
          <irembogov-workflow-state-selector
            #stateSelector
            [workflowConfig]="workflowConfig"
            [initialState]="selectedAssignment?.workflowContext"
            (stateSelected)="onStateSelected($event)">
          </irembogov-workflow-state-selector>
        </div>

        <!-- Assignment Form -->
        <ng-container *ngIf="selectedState">
          <irembogov-office-assignment-form
            [workflowState]="getWorkflowState()"
            [currentAssignment]="getCurrentFormAssignment()"
            [workflowConfig]="workflowConfig"
            [organizationId]="organizationId"
            (assignmentChange)="onAssignmentChange($event)"
            (cancel)="onCancel()">
          </irembogov-office-assignment-form>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>
